module.exports = __webpack_public_path__ + "img/logo_pno_fb.986f2f9f.png";